var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('v-app',{attrs:{"dark":"","permanent":""}},[_c('HeaderLayout',{attrs:{"withoutCategory":false,"permanent":""}}),_c('Nuxt',{staticClass:"classMargin"}),_c('FooterLayout'),_c('CookiesSnackbar')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }